import script from "./GeneratorIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratorIndex.vue?vue&type=script&setup=true&lang=js"

import "./GeneratorIndex.vue?vue&type=style&index=0&id=180a2851&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180a2851"]])

export default __exports__